"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _CustomChargeStore = require("../../../stores/CustomChargeStore.jsx");

var _CustomChargeStore2 = _interopRequireDefault(_CustomChargeStore);

var _CartStore = require("../../../stores/CartStore.jsx");

var _CartStore2 = _interopRequireDefault(_CartStore);

var _Utility = require("../../../utils/Utility.jsx");

var Utils = _interopRequireWildcard(_Utility);

var _reactTooltip = require("react-tooltip");

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _Actions = require("../../../Actions.jsx");

var _Actions2 = _interopRequireDefault(_Actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DELIVERY = "Delivery";
var PICKUP = "PickUp";
var CURBSIDEPICKUP = "CurbsidePickUp";
var DINEIN = "DineIn";

var RoundUpChargeView = function (_React$Component) {
    _inherits(RoundUpChargeView, _React$Component);

    function RoundUpChargeView(props) {
        _classCallCheck(this, RoundUpChargeView);

        return _possibleConstructorReturn(this, (RoundUpChargeView.__proto__ || Object.getPrototypeOf(RoundUpChargeView)).call(this, props));
    }

    // UNSAFE_componentWillMount() {
    //
    //     this.setState({
    //         orderType   : this.props.orderType
    //     });
    //
    //
    // }

    // UNSAFE_componentWillReceiveProps(nextProps) {
    //
    //     if(nextProps.orderType != this.props.orderType) {
    //
    //         this.setState({
    //             orderType   : nextProps.order
    //         });
    //     }
    //
    // }

    _createClass(RoundUpChargeView, [{
        key: "isCurbsidePickUpEnabled",
        value: function isCurbsidePickUpEnabled() {

            // check the ordertype is PickUp and Curbside PickUp option is selected
            if (this.props.orderType == PICKUP && _CartStore2.default.getIsPreferCurbsideEnabled()) {
                return true;
            } else {
                return false;
            }
        }
    }, {
        key: "getCustomChargesRoundUpStructure",
        value: function getCustomChargesRoundUpStructure() {
            var _this2 = this;

            if (_CustomChargeStore2.default.isCustomChargeConfigured()) {

                var orderType = null;
                if (this.isCurbsidePickUpEnabled()) {
                    orderType = CURBSIDEPICKUP;
                } else {
                    orderType = this.props.orderType;
                }

                var roundOffCharge = _CustomChargeStore2.default.getCustomChargeConfig(orderType, "R");

                if (roundOffCharge && roundOffCharge.length > 0) {

                    var i = 0;
                    // return roundOffCharge.map((charge) => {

                    var charge = roundOffCharge[0];

                    var longDesc = charge.typeDetails.longDesc;

                    var chargeTypeValues = charge.typeDetails.values;

                    // let chargeFee = CustomChargeStore.getCustomChargeFeeRounded(chargeTypeValues);

                    var checkboxDetail = "";
                    if (!Utils.isEmpty(charge.desc)) {

                        checkboxDetail = charge.desc;
                    } else {
                        checkboxDetail = "Yes, I want to round up.";
                    }

                    var descComponent = null;
                    if (!Utils.isEmpty(longDesc)) {
                        descComponent = _react2.default.createElement(
                            "span",
                            null,
                            _react2.default.createElement(
                                "a",
                                { "data-tip": longDesc,
                                    className: 'color-styl tooltip-button',
                                    style: { cursor: 'pointer' },
                                    tabIndex: 50
                                },
                                _react2.default.createElement("i", { className: "fa fa-info-circle"

                                })
                            ),
                            _react2.default.createElement(_reactTooltip2.default, { place: "right", wrapper: "span" })
                        );
                    }

                    var chargeLogo = false;
                    if (charge && charge.typeDetails && charge.typeDetails.logoURL) {
                        Utils.checkIfImageExists(charge.typeDetails.logoURL, function (exists) {
                            if (exists) {
                                // Success code
                                chargeLogo = true;
                            }
                        });
                    }

                    var component = _react2.default.createElement(
                        "div",
                        { key: i, className: "row round-off-main" },
                        _react2.default.createElement(
                            "div",
                            { className: "col-md-12" },
                            _react2.default.createElement(
                                "h4",
                                { className: "round-off-heading f16-default" },
                                charge.name
                            ),
                            _react2.default.createElement(
                                "div",
                                { className: "btn-group btn-group-justified center-block" },
                                _react2.default.createElement(
                                    "table",
                                    { className: "table" },
                                    _react2.default.createElement(
                                        "tbody",
                                        null,
                                        _react2.default.createElement(
                                            "tr",
                                            null,
                                            chargeLogo ? _react2.default.createElement(
                                                "td",
                                                { className: "col-1 cart-rounded rounded-item-td" },
                                                _react2.default.createElement(
                                                    "div",
                                                    { className: "media" },
                                                    _react2.default.createElement(
                                                        "a",
                                                        { href: charge.typeDetails.infoLink, target: "_blank", tabIndex: 49 },
                                                        _react2.default.createElement("img", {
                                                            src: charge.typeDetails.logoURL,
                                                            title: "Health Logo Title",
                                                            alt: "Health Logo Title",
                                                            className: "img-in-cart-1 img-rounded img-responsive" })
                                                    )
                                                )
                                            ) : null,
                                            _react2.default.createElement(
                                                "td",
                                                { className: "col-11 rounded-item-td", style: { textAlign: 'left' } },
                                                _react2.default.createElement(
                                                    "div",
                                                    null,
                                                    _react2.default.createElement(
                                                        "h4",
                                                        { className: "item-in-cart" },
                                                        charge.typeDetails.name,
                                                        " ",
                                                        descComponent
                                                    ),
                                                    _react2.default.createElement(
                                                        "h5",
                                                        { className: "ft-14" },
                                                        charge.typeDetails.desc
                                                    ),
                                                    _react2.default.createElement(
                                                        "div",
                                                        { className: " checkbox-div" },
                                                        _react2.default.createElement(
                                                            "label",
                                                            {
                                                                className: "container-checkbox remove-margin-top pull-left chk-lbl cart-header" },
                                                            _react2.default.createElement(
                                                                "b",
                                                                null,
                                                                checkboxDetail
                                                            ),
                                                            _react2.default.createElement("input", { type: "checkbox",
                                                                id: "round-off-id",
                                                                name: "round-off-name",
                                                                checked: _CartStore2.default.getRoundOffStatus(),
                                                                tabIndex: 51
                                                                //    onChange={this.clickedRoundOffOption}
                                                                , onChange: function onChange(event) {
                                                                    return _this2.clickedRoundOffOption(event, charge);
                                                                }
                                                            }),
                                                            _react2.default.createElement("span", { className: "checkmark" })
                                                        ),
                                                        _react2.default.createElement("span", { className: "clearfix" })
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            ),
                            !this.props.isMobile ? _react2.default.createElement("span", { className: "col-12 mb-0 cart_border d-inline-block" }) : null
                        )
                    );

                    // i = i +1;
                    return component;

                    // });

                } else {
                    return null;
                }
            } else {
                return null;
            }
        }
    }, {
        key: "clickedRoundOffOption",
        value: function clickedRoundOffOption(e, chargeObj) {

            // Sub total value
            var total = _CartStore2.default.getCartTotalRoundedWithCustomCharges();

            _Actions2.default.updateRoundOffStatus(e.target.checked, chargeObj);
        }
    }, {
        key: "render",
        value: function render() {

            return _react2.default.createElement(
                "div",
                null,
                this.getCustomChargesRoundUpStructure()
            );
        }
    }]);

    return RoundUpChargeView;
}(_react2.default.Component);

exports.default = RoundUpChargeView;


//////////////////
// WEBPACK FOOTER
// ./src/components/cart-view/custom-charge/RoundUpChargeView.jsx
// module id = 735
// module chunks = 0